/* =========================================================================
   BAZAR DA BLUMI — CARTÃO "APROVEITE, É ATÉ 50% OFF" NA GAVETA (09/10/2026)

   Lê o estado publicado pela gaveta (snippets/tp-bazar-carrinho.liquid,
   <script data-tp-bz>), que a gaveta refaz a cada mudança do carrinho. Pedido
   do Guilherme: "TODA VEZ que colocar um produto no carrinho -> pop-up
   induzindo a cliente a aproveitar e comprar mais, porque a promo é de até
   50% OFF e vai acabar". REVISTO 09/10 à noite (Guilherme): "só pro primeiro
   produto... ele só deve aparecer 1x, independente do que a cliente escolher,
   porque quem já botou 2 produtos diferentes já está bem encaminhada". Então:
   abre UMA vez, quando a 1ª peça do Bazar entra no carrinho, e nunca mais
   (localStorage tp-bz-visto, por navegador, vale a campanha inteira). "Não,
   obrigada" fecha; "Ver peças" volta à coleção.

   O cartão também lembra do cupom (quanto ele tira do que já está no carrinho)
   e tem o botão "aplicar", que abre /discount/CODIGO em segundo plano: a
   Shopify grava o cupom nesta visita e o checkout já vem com ele.

   A OFERTA MANDA: ao abrir, avisa (evento tp-oferta-cartao) e os cartões da
   roleta saem de cena.
   ========================================================================= */
(function () {
  if (window.__tpBazar) return;
  window.__tpBazar = true;

  var raiz = null, timer = null, visto = null, vistoTxt = null;
  /* VÁRIAS CAMPANHAS (09/10 noite): o estado traz `handle` (bazar, data-dupla...); "já viu" e
     "última quantidade" são por campanha, para a Data Dupla não herdar o "visto" do Bazar. */
  var campanha = '';
  var ultimaQtd = null;
  function kQtd() { return 'tp-bz-qtd' + (campanha ? ':' + campanha : ''); }
  function kVisto() { return 'tp-bz-visto' + (campanha ? ':' + campanha : ''); }
  function carregarQtd() { try { ultimaQtd = parseInt(sessionStorage.getItem(kQtd()) || '', 10); if (isNaN(ultimaQtd)) ultimaQtd = null; } catch (e) { ultimaQtd = null; } }
  function jaVisto() { try { return localStorage.getItem(kVisto()) === '1'; } catch (e) { return false; } }
  function marcarVisto() { try { localStorage.setItem(kVisto(), '1'); } catch (e) {} }
  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function avisar(aberto) { try { document.dispatchEvent(new CustomEvent('tp-oferta-cartao', { detail: { aberto: !!aberto, quem: 'bazar' } })); } catch (e) {} }
  function diasRestantes(fim) { if (!fim) return null; var d = Math.ceil((fim * 1000 - Date.now()) / 86400000); return d < 0 ? 0 : d; }

  function montar() {
    if (raiz) return raiz;
    var css = document.createElement('style');
    css.textContent = '.tp-bzc{position:fixed;z-index:2147483000;left:50%;bottom:16px;width:min(100% - 24px,380px);transform:translate(-50%,16px);opacity:0;display:flex;align-items:flex-start;gap:12px;padding:14px 16px 14px 14px;border-radius:16px;background:#222F28;color:#F1F0EB;box-shadow:0 10px 30px rgba(34,47,40,.28);font-family:var(--tp-body-font,"Host Grotesk",ui-sans-serif,system-ui,sans-serif);transition:opacity .22s ease,transform .22s ease}'
      + '.tp-bzc[hidden]{display:none}.tp-bzc.is-aberto{opacity:1;transform:translate(-50%,0)}'
      + '@media (min-width:750px){.tp-bzc{left:auto;right:20px;bottom:20px;transform:translateY(16px)}.tp-bzc.is-aberto{transform:translateY(0)}}'
      + '.tp-bzc__icone{flex:0 0 auto;width:38px;height:38px;border-radius:12px;background:rgba(255,170,153,.18);color:#FFAA99;display:inline-flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;letter-spacing:-.02em}'
      + '.tp-bzc__corpo{flex:1 1 auto;min-width:0}.tp-bzc__eyebrow{margin:0 0 2px;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#FFAA99;font-weight:600}'
      + '.tp-bzc__titulo{margin:0 0 4px;font-size:1.45rem;line-height:1.3;font-weight:600}.tp-bzc__titulo b{color:#FFAA99;font-weight:700}'
      + '.tp-bzc__texto{margin:0 0 10px;font-size:1.2rem;line-height:1.4;color:rgba(241,240,235,.78)}.tp-bzc__texto b{color:#F1F0EB;font-weight:700}'
      + '.tp-bzc__cupom{display:inline-flex;align-items:center;gap:6px;margin:0 0 10px;padding:5px 9px;border:1px dashed rgba(241,240,235,.5);border-radius:8px;background:transparent;color:#F1F0EB;font:inherit;font-size:1.15rem;cursor:pointer}'
      + '.tp-bzc__cupom b{letter-spacing:.06em;font-weight:700}.tp-bzc__cupom em{font-style:normal;padding:1px 6px;border-radius:999px;background:#FFAA99;color:#222F28;font-size:9.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}'
      + '.tp-bzc__cupom.is-ok{border-style:solid;border-color:#FFAA99}'
      + '.tp-bzc__acoes{display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
      + '.tp-bzc__sim{display:inline-flex;align-items:center;padding:9px 14px;border-radius:999px;background:#FFAA99;color:#222F28;font-size:1.25rem;font-weight:700;text-decoration:none}'
      + '.tp-bzc__nao{border:0;background:transparent;padding:6px 2px;color:rgba(241,240,235,.75);font:inherit;font-size:1.2rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-bzc';
    el.setAttribute('role', 'status');
    el.hidden = true;
    el.innerHTML = '<span class="tp-bzc__icone" aria-hidden="true">50%</span>'
      + '<div class="tp-bzc__corpo"><p class="tp-bzc__eyebrow" data-bzc-eyebrow>Bazar da Blumi</p><p class="tp-bzc__titulo" data-bzc-titulo></p><p class="tp-bzc__texto" data-bzc-texto></p>'
      + '<button type="button" class="tp-bzc__cupom" data-bzc-cupom>Cupom <b data-bzc-codigo></b> <em data-bzc-estado>aplicar</em></button>'
      + '<div class="tp-bzc__acoes"><a class="tp-bzc__sim" data-bzc-sim href="#">Ver mais peças</a><button type="button" class="tp-bzc__nao" data-bzc-nao>Não, obrigada</button></div></div>';
    document.body.appendChild(el);
    el.querySelector('[data-bzc-nao]').addEventListener('click', function () { fechar(); });
    el.querySelector('[data-bzc-sim]').addEventListener('click', function () { fechar(); });
    el.querySelector('[data-bzc-cupom]').addEventListener('click', function () {
      var btn = this, codigo = btn.getAttribute('data-codigo') || '', rot = btn.querySelector('[data-bzc-estado]');
      /* 27/10/2026: assets/tp-cupom-ok.js aplica (substitui qualquer outro cupom e redesenha a gaveta),
         anima e avisa no topo "BAZAR15 aplicado". Sem o ajudante, caminho antigo. */
      if (window.tpCupomOk) {
        window.tpCupomOk.aplicar(btn, codigo, { rotulo: rot, textoOk: 'aplicado', toastTexto: codigo + ' aplicado', codigoEl: btn.querySelector('[data-bzc-codigo]') })
          .then(function (ok) { if (ok) btn.classList.add('is-ok'); });
        return;
      }
      var ok = function () { btn.classList.add('is-ok'); if (rot) rot.textContent = 'aplicado'; try { sessionStorage.setItem('tp-cupom-aplicado', codigo); } catch (e) {} };
      try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo).catch(function () {}); } catch (e) {}
      fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).then(ok, ok);
    });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { setTimeout(posicionar, 350); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', posicionar);
    raiz = el;
    return el;
  }
  function posicionar() {
    if (!raiz) return;
    if (window.innerWidth < 750) { raiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    raiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function fechar() {
    if (!raiz || raiz.hidden) return;
    var estavaAberto = raiz.classList.contains('is-aberto');
    raiz.classList.remove('is-aberto');
    var el = raiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
    if (estavaAberto) avisar(false);
  }
  function bloqueado() {
    var h = document.documentElement.classList;
    return h.contains('tp-roleta-open') || h.contains('tp-pg-open') || h.contains('tp-pt-open') || h.contains('tp-pe-open');
  }

  var pendente = false; /* subiu a quantidade com um pop-up na frente: abre quando ele sair */
  function decidir() {
    var el = document.querySelector('[data-tp-bz]');
    if (!el) { fechar(); return; }
    var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }
    if (d.handle !== campanha) { campanha = d.handle || ''; carregarQtd(); }
    if (!d.ativa || !d.qtd) { fechar(); lembrar(d ? d.qtd : 0); return; }
    if (d.fim && Date.now() / 1000 > d.fim) { fechar(); return; }
    var subiu = ultimaQtd === null ? d.qtd > 0 : d.qtd > ultimaQtd;
    lembrar(d.qtd);
    if (!subiu && !pendente) return;
    if (jaVisto()) { pendente = false; return; } /* uma vez só, por campanha */
    if (bloqueado()) { pendente = true; return; }
    pendente = false;
    marcarVisto();
    var box = montar();
    var dias = diasRestantes(d.fim);
    var prazo = dias === null ? '' : (dias <= 1 ? 'Acaba hoje.' : 'Só até ' + new Date(d.fim * 1000).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) + '.');
    box.querySelector('[data-bzc-eyebrow]').textContent = (d.titulo || 'Bazar da Blumi') + ' · ' + (d.destaque || 'até 50% OFF');
    box.querySelector('[data-bzc-titulo]').innerHTML = 'Aproveite e leve mais peças com <b>' + (d.destaque || 'até 50% OFF').replace(/^at[eé]\s*/i, 'até ') + '</b>';
    box.querySelector('[data-bzc-texto]').innerHTML = prazo + (d.cupomTira > 0 ? ' O cupom tira <b>' + brl(d.cupomTira) + '</b> do que já está no carrinho.' : '');
    var cup = box.querySelector('[data-bzc-cupom]');
    cup.setAttribute('data-codigo', d.cupom || '');
    box.querySelector('[data-bzc-codigo]').textContent = d.cupom || '';
    var aplicado = false; try { aplicado = sessionStorage.getItem('tp-cupom-aplicado') === d.cupom; } catch (e) {}
    cup.classList.toggle('is-ok', aplicado); cup.querySelector('[data-bzc-estado]').textContent = aplicado ? 'aplicado' : 'aplicar';
    var sim = box.querySelector('[data-bzc-sim]');
    if (d.url) { sim.href = d.url; sim.hidden = false; } else sim.hidden = true;
    var jaAberto = box.classList.contains('is-aberto');
    if (box.hidden) { box.hidden = false; void box.offsetWidth; }
    box.classList.add('is-aberto');
    posicionar();
    if (!jaAberto) avisar(true);
  }
  function lembrar(q) { ultimaQtd = q || 0; try { sessionStorage.setItem(kQtd(), String(ultimaQtd)); } catch (e) {} }

  function mudou() {
    var el = document.querySelector('[data-tp-bz]');
    if (!el) return visto !== null ? ((visto = null), true) : false;
    var txt = el.textContent;
    if (el === visto && txt === vistoTxt) return false;
    visto = el; vistoTxt = txt;
    return true;
  }
  function agendar() { clearTimeout(timer); timer = setTimeout(decidir, 120); }
  function iniciar() {
    mudou();
    decidir();
    var gaveta = document.getElementById('CartDrawer');
    if (gaveta && window.MutationObserver) new MutationObserver(function () { if (mudou()) agendar(); }).observe(gaveta, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { subscribe(PUB_SUB_EVENTS.cartUpdate, agendar); } catch (e) {} }
    if (window.MutationObserver) {
      var estava = bloqueado();
      new MutationObserver(function () { var agora = bloqueado(); if (agora && !estava) fechar(); if (estava && !agora && pendente) setTimeout(decidir, 500); estava = agora; }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
